/* Bug Fix: 
    https://github.com/angular/angular.js/issues/10071
    https://stackoverflow.com/questions/25818757/set-angularjs-nested-forms-to-submitted/30138961#30138961
*/

(function () {
    'use strict';

    angular
        .module('app.shared')
        .directive('form', formDirective)
        .directive('ngForm', ngFormDirective);

    function formDirective() {
        return {
            restrict: 'E',
            require: 'form',
            link: link
        };

        function link(scope, elem, attrs, formCtrl) {
            scope.$watch(
                function () {
                    return formCtrl.$submitted;
                },
                function (submitted) {
                    submitted && scope.$broadcast('$submitted');
                }
            );
        }
    }

    function ngFormDirective() {
        return {
            restrict: 'EA',
            require: 'form',
            link: link
        };

        function link(scope, elem, attrs, formCtrl) {
            scope.$on('$submitted', function () {
                formCtrl.$setSubmitted();
            });
        }
    }
})();